import { LogErrors } from './../../LogErrors'

import { DoubleAttempt } from './../Helpers/DoubleAttempt'


const GetZtudents = async (idCenter, token) => {
    try {
        const dataToSend = {
            idCenter: idCenter
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/GetAllZtudentsByInstructor"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetZtudents - DL Ztudents', error)
        return { success: false, message: `No ha sido posible obtener el listado de Ztudiantes. Intenta actualizar la página o intenta actualizarla más tarde.` }
    }
}

const HideToZtudent = async (idZtudiante, idCenter, token) => {
    try {
        const dataToSend = {
            idZtudiante: idZtudiante,
            idCenter: idCenter
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/HideZtudianteFromAllGroups"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('HideToZtudent - DL Ztudents', error)
        return { success: false, message: `No ha sido posible ocultar al Ztudiante. Inténtalo nuevamente o más tarde.` }
    }
}

const ShowToZtudent = async (idZtudiante, idCenter, token) => {
    try {
        const dataToSend = {
            idZtudiante: idZtudiante,
            idCenter: idCenter
        }

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }
        
        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/ShowZtudianteFromAllGroups"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('ShowToZtudent - DL Ztudents', error)
        return { success: false, message: `No ha sido posible mostrar al Ztudiante. Inténtalo nuevamente o más tarde.` }
    }
}

const ResetZtudiantePassword = async (idCenter, idZtudiante, username, token) => {
    try {
        const dataToSend = {
            idCenter: idCenter,
            idZtudiante: idZtudiante,
            username: username
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/ResetZtudiantePassword"

        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('ResetZtudiantePassword - DL Ztudents', error)
        return { success: false, message: `No ha sido posible mostrar al Ztudiante. Inténtalo nuevamente o más tarde.` }
    }
}

/**
 * Importa Ztudiantes de forma masiva a un grupo a partir de un libro de Excel.
 * El proceso en el backend es "todo o nada": si alguna fila falla, no se importa ninguna.
 *
 * @param {string} groupAccessCode - Código de acceso del grupo destino.
 * @param {number} centerId - Identificador del centro.
 * @param {number} idUserRol - Rol del usuario que importa (2 = instructor).
 * @param {File} fileObj - Archivo .xlsx con las columnas Nombre(s), Apellido(s), Usuario.
 * @param {string} token - Token de sesión.
 */
const ImportStudentsFromXlsx = async (groupAccessCode, centerId, idUserRol, fileObj, token) => {
    try {
        const formData = new FormData()
        formData.append('groupAccessCode', groupAccessCode)
        formData.append('centerId', centerId)
        formData.append('idUserRol', idUserRol)
        formData.append('file', fileObj)

        const parameters = {
            method: 'POST',
            headers: {
                'Authorization': token
                // OJO: No colocar 'Content-Type' aquí, el navegador debe fijar el boundary del multipart.
            },
            body: formData
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V2/Api/ImportStudentsFromXlsx`
        const response = await fetch(url, parameters)
        const jsonResponse = await response.json()

        if (response.ok && jsonResponse.success !== false) {
            return { success: true, data: jsonResponse, message: jsonResponse.message }
        } else {
            // Se devuelve también el cuerpo en el error: trae summary/issues con el detalle del rechazo
            return { success: false, data: jsonResponse, message: jsonResponse.message || 'No fue posible importar a los Ztudiantes.' }
        }
    } catch (error) {
        await LogErrors('ImportStudentsFromXlsx - DL Ztudents', error)
        return { success: false, message: `No ha sido posible cargar el archivo de Ztudiantes.` }
    }
}

export { GetZtudents, HideToZtudent, ShowToZtudent, ResetZtudiantePassword, ImportStudentsFromXlsx };